import * as THREE from 'three'
import CurvedPlaneGeometry from '@/geometries/CurvedPlaneGeometry'

export default class Road extends THREE.Mesh {
  name = 'Road'

  constructor (points, width, color = 0xffffff) {
    const material = new THREE.MeshBasicMaterial({ color })
    const geometry = new CurvedPlaneGeometry(points.map(([ x, y ]) =>
      new THREE.Vector2(x, y)
    ), width, 1000)

    super(geometry, material)
  }

  setColor (color) {
    this.material.color = new THREE.Color(color)
  }

  setTexture (texture, transparent = false) {
    // TODO: texture size (256) should be loaded dynamically
    texture.wrapT = THREE.RepeatWrapping
    texture.wrapS = THREE.RepeatWrapping
    texture.repeat.set(1, this.geometry.length / 25.6)

    if (transparent) {
      this.material.alphaMap = texture
      this.material.transparent = transparent
    } else {
      this.material.map = texture
    }
  }
}
